import { isServer } from '@frameio/utils';
import { getCookie } from '@frameio/utils/cookies';

const oneTrustCookieName = 'OptanonConsent';

function formatValue(value: string) {
  if (value === '1') {
    return true;
  }
  if (value === '0') {
    return false;
  }
  return value;
}

function getOneTrustCookieGroupsArray() {
  if (isServer) return [];
  const oneTrustCookieValue = getCookie(oneTrustCookieName);
  if (!oneTrustCookieValue) return [];

  const params = new URLSearchParams(oneTrustCookieValue);
  const groupsString = params.get('groups');
  if (!groupsString) return [];

  return groupsString.split(',');
}

// owned by Adobe's OneTrust config and changes very rarely.
const ALL_COOKIE_GROUPS = ['C0001', 'C0002', 'C0003', 'C0004'];

function getOverrideCategoryPreferences(
  consentOverride: string[]
): Record<string, unknown> {
  const granted = new Set(consentOverride);
  return Object.fromEntries(
    ALL_COOKIE_GROUPS.map((group) => [group, granted.has(group)])
  );
}

function getCookieCategoryPreferences(): Record<string, unknown> {
  const categoryPreferences: Record<string, unknown> = {};
  getOneTrustCookieGroupsArray().forEach((group) => {
    const [key, value] = group.split(':');
    categoryPreferences[key] = formatValue(value);
  });
  return categoryPreferences;
}

export function getOneTrustConsent(
  isEdu?: boolean,
  consentOverride?: string[] | null
) {
  const categoryPreferences =
    consentOverride != null
      ? getOverrideCategoryPreferences(consentOverride)
      : getCookieCategoryPreferences();

  if (Object.keys(categoryPreferences).length === 0) return {};

  if (isEdu) {
    categoryPreferences.C0004 = false;
  }

  return {
    consent: {
      categoryPreferences,
    },
  };
}

export function getOneTrustConsentInput() {
  const groupsArray = getOneTrustCookieGroupsArray();
  if (groupsArray.length === 0) return undefined;

  const categoryPreferences: Record<string, unknown> = {};
  groupsArray.forEach((group) => {
    const [key, value] = group.split(':');
    // the backend expects the keys to be lowercase
    categoryPreferences[key.toLowerCase()] = formatValue(value);
  });

  return categoryPreferences;
}
